/*
 * @Author: Json Chen
 * @Date: 2021-07-26 20:30:25
 * @LastEditTime: 2022-06-07 18:08:08
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Localisation/Components/AddressFormats.tsx
 */

import { Button, Modal, SizeFittingTable } from '@/src/components/Antd';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import DropdownActions from '@/src/pages/Settings/Logistics/Components/DropdownActions';
import { Icon } from '@/src/tools/icon';
import { Collapse, Input, Menu } from 'antd';
import React, {
  useEffect,
  useMemo,
  useRef,
  // memo,
  useState,
} from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { checkboxOptions } from '../config';
import styles from '../style.module.less';
import AddressFormatModalForm from './AddressFormatModalForm';

// const EditInput = memo(
//   ({ value, onChange }) => {
//     const [_value, _setValue] = useState(value);
//     const [editing, setEditing] = useState(false);
//     const inputRef = useRef<Input>(null);

//     const handleSave = (e) => {
//       onChange(_value);
//       toggleEdit();
//     };
//     useEffect(() => {
//       if (editing) {
//         inputRef.current!.focus();
//       }
//     }, [editing]);

//     const toggleEdit = () => {
//       setEditing(!editing);
//     };

//     return editing ? (
//       <Input
//         value={_value}
//         onChange={(e) => {
//           // onChange(e.target.value);
//           _setValue(e.target.value);
//         }}
//         ref={inputRef}
//         onPressEnter={handleSave}
//         onBlur={handleSave}
//       />
//     ) : (
//       <div onClick={toggleEdit} className={styles.editInput}>
//         {value}
//       </div>
//     );
//   },
//   (p, c) => {
//     return p.value === c.value;
//   },
// );

const EditInput = ({ value, onChange, placeholder, disabled }: any) => {
  const [_value, _setValue] = useState(value);
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<Input>(null);

  const handleSave = (e) => {
    onChange(_value);
    toggleEdit();
  };
  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  return editing ? (
    <Input
      value={_value}
      onChange={(e) => {
        // onChange(e.target.value);
        _setValue(e.target.value);
      }}
      className={styles.editInputBox}
      placeholder={placeholder}
      ref={inputRef}
      onPressEnter={handleSave}
      onBlur={handleSave}
      disabled={disabled}
    />
  ) : (
    <div onClick={toggleEdit} className={styles.editInput}>
      {value}
    </div>
  );
};

const AddressFormats = ({ value, onChange, disableEdit }: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visiable, setVisiable] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<any>();
  const [modalContent, setModalContent] = useState<any>();
  const list = useMemo(() => value || [], [value]);
  const showModal = () => {
    setVisiable(true);
  };
  const hideModal = () => {
    setVisiable(false);
  };

  // const onInputChange = (v, fieldType, index) => {
  //   const newList = list.map((item, i) => {
  //     return index === i
  //       ? {
  //           ...item,
  //           fields: item.fields.map((f) =>
  //             f.fieldType === fieldType
  //               ? {
  //                   ...f,
  //                   fieldName: v,
  //                 }
  //               : f,
  //           ),
  //         }
  //       : item;
  //   });
  //   onChange(newList);
  // };

  const onRegexChange = (v, fieldType, index) => {
    const newList = list.map((item, i) => {
      return index === i
        ? {
            ...item,
            fields: item.fields.map((f) =>
              f.fieldType === fieldType
                ? {
                    ...f,
                    regex: v,
                  }
                : f,
            ),
          }
        : item;
    });
    onChange(newList);
  };

  const fieldsOut = ['Subdivision', 'City'];
  const getDefaultColumns = (index): any => {
    return [
      {
        title: getI18n('storeLocalisation.component.addressField'),
        dataIndex: 'fieldType',
        default: true,
        minWidth: 375,
        childGenerate: (text, record) => {
          return <div>{text}</div>;
        },
      },
      {
        title: (
          <div>
            {/* <span>
              <Icon type='iconedit' />
            </span> */}
            <span>{getI18n('storeLocalisation.component.fieldName')}</span>
          </div>
        ),
        dataIndex: 'fieldName',
        default: true,
        editable: true,
        minWidth: 375,
        childGenerate: (text, record) => {
          return (
            <div>
              {text}
              {/* <EditInput
                value={text}
                placeholder=''
                onChange={(e) => onInputChange(e, record.fieldType, index)}
                disabled={disableEdit}
              /> */}
            </div>
          );
        },
      },
      {
        title: (
          <div>
            <span>
              <Icon type='iconedit' />
            </span>
            <span>
              {getI18n(
                'storeLocalisation.component.advancedValidationExpressionregex',
              )}
            </span>
          </div>
        ),
        dataIndex: 'regex',
        default: true,
        editable: true,
        minWidth: 375,
        childGenerate: (text, record) => {
          return fieldsOut.includes(record.fieldType) ? (
            <div>{text}</div>
          ) : (
            <EditInput
              value={text}
              placeholder='/ [ \x00-\xFF ] /'
              onChange={(e) => onRegexChange(e, record.fieldType, index)}
              disabled={disableEdit}
            />
          );
        },
      },
    ];
  };

  const getCustomColumns = (index): any => {
    return getDefaultColumns(index).concat({
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      width: 250,
      childGenerate: (_, record) => {
        // checkedable 为true 不在可选列表中,也不能删除
        const deleteable = checkboxOptions({ getI18n }).find(
          (c) => c.fieldType === record.fieldType,
        ).checkedable;
        return (
          <div className={styles.action}>
            {deleteable && (
              <span
                className={styles.danger}
                onClick={() => onCustomItemDelete(record.fieldType, index)}>
                {getI18n('general.delete')}
              </span>
            )}
          </div>
        );
      },
    });
  };

  const onEdit = (index) => {
    setModalTitle(getI18n('storeLocalisation.component.editAddressFormat'));
    setModalContent(
      <AddressFormatModalForm
        onCancel={hideModal}
        onModalConfirm={onModalConfirm}
        existList={list}
        editIndex={index}
      />,
    );
    showModal();
  };
  const onCustomDelete = (index) => {
    onChange(list.filter((_, i) => i !== index));
  };
  const onCustomItemDelete = (fieldType, index) => {
    onChange(
      list.map((item, i) => {
        return i === index
          ? {
              ...item,
              fields: item.fields.filter((f) => f.fieldType !== fieldType),
            }
          : item;
      }),
    );
  };
  const onTableChange = (p, index) => {
    onChange(
      list.map((item, i) => {
        return i === index
          ? {
              ...item,
              fields: p,
            }
          : item;
      }),
    );
  };
  const onModalConfirm = (data, editIndex) => {
    let newList = [];
    if (editIndex || editIndex === 0) {
      newList = list.map((item, index) =>
        editIndex === index ? { ...item, ...data } : item,
      );
    } else {
      newList = list.concat({
        ...data,
        customized: true,
      });
    }

    onChange(newList);
  };
  const onAddClick = () => {
    setModalTitle(getI18n('storeLocalisation.component.addAddressFormat'));
    setModalContent(
      <AddressFormatModalForm
        onCancel={hideModal}
        onModalConfirm={onModalConfirm}
        existList={list}
      />,
    );
    showModal();
  };
  return (
    <div>
      <Collapse
        accordion
        // activeKey={actives} onChange={onCollapseChange}
      >
        {list.map((item, index) => {
          return item.customized ? (
            <Collapse.Panel
              className={styles.customAddress}
              header={
                <div className={styles.collapseContent}>
                  <div>{item.name}</div>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}>
                    <DropdownActions index={index}>
                      <Menu>
                        <Menu.Item
                          key='1'
                          className={styles.dropMenuItem}
                          onClick={() => onEdit(index)}>
                          <div className={styles.editBtns}>
                            {getI18n('storeLocalisation.component.editFormat')}
                          </div>
                        </Menu.Item>
                        <Menu.Item
                          key='2'
                          onClick={() => onCustomDelete(index)}>
                          <div
                            className={`${styles.danger} ${styles.editBtns}`}>
                            {getI18n('general.delete')}
                          </div>
                        </Menu.Item>
                      </Menu>
                    </DropdownActions>
                  </div>
                </div>
              }
              key={index}>
              <DroppableTable
                id='CustomAddressFormat'
                // components={components}
                rowKey={'fieldType'}
                columns={getCustomColumns(index)}
                dataSource={item.fields}
                pagination={false}
                onTableChange={(p) => onTableChange(p, index)}
              />
            </Collapse.Panel>
          ) : (
            <Collapse.Panel
              className={styles.defaultAddress}
              header={<div className={styles.collapseContent}>{item.name}</div>}
              key={index}>
              <SizeFittingTable
                id='DefaultAddressFormat'
                rowKey='fieldName'
                columns={getDefaultColumns(index)}
                dataSource={item.fields}
                pagination={false}
              />
            </Collapse.Panel>
          );
        })}
      </Collapse>
      <Button
        className={styles.addCustomisedFomatButton}
        type='primary'
        disabled={disableEdit}
        onClick={onAddClick}>
        {getI18n('storeLocalisation.component.addCustomisedFormat')}
      </Button>
      <Modal
        className={styles.courierAccountModal}
        width={600}
        visible={visiable}
        onCancel={hideModal}
        title={modalTitle}>
        {modalContent}
      </Modal>
    </div>
  );
};

export default AddressFormats;
